// import React, { useEffect, useMemo, useRef } from "react";
// import { Stack } from "react-bootstrap";
// import { colors } from "src/styles";
// import styled from "styled-components";
// import * as d3 from "d3";

// interface WorkOrderByLocation {
//   locationName: string;
//   count: number;
// }

// interface WidgetProps {
//   caption: string;
//   preloadedData?: { widgetsData: { workOrdersByLocation: WorkOrderByLocation[] } };
// }

// interface WorkOrderData {
//   location: string;
//   count: number;
// }

// const toNumber = (value: unknown): number => {
//   const parsed = Number(value);
//   return Number.isFinite(parsed) ? parsed : 0;
// };

// const WorkOrdersLocationChart = ({ caption, preloadedData }: WidgetProps) => {
//   const svgRef = useRef<SVGSVGElement>(null);
//   const containerRef = useRef<HTMLDivElement>(null);

//   const completedWorkData: WorkOrderData[] = useMemo(() => {
//     return (preloadedData?.widgetsData?.workOrdersByLocation ?? [])
//       .map((item, index) => ({
//         location: String(item?.locationName ?? `Location ${index + 1}`),
//         count: toNumber(item?.count),
//       }))
//       .sort((a, b) => b.count - a.count);
//   }, [preloadedData]);

//   useEffect(() => {
//     if (!svgRef.current || completedWorkData.length === 0) return;

//     const margin = { top: 8, right: 20, bottom: 28, left: 100 };
//     const containerWidth = containerRef.current?.clientWidth || 300;
//     const width = containerWidth - margin.left - margin.right;
//     const rowHeight = 28;
//     const height = completedWorkData.length * rowHeight;

//     d3.select(svgRef.current).selectAll("*").remove();

//     const svg = d3
//       .select(svgRef.current)
//       .attr("width", width + margin.left + margin.right)
//       .attr("height", height + margin.top + margin.bottom)
//       .append("g")
//       .attr("transform", `translate(${margin.left},${margin.top})`);

//     const maxCount = d3.max(completedWorkData, (d) => d.count) || 0;
//     const x = d3
//       .scaleLinear()
//       .domain([0, maxCount + Math.ceil(maxCount * 0.15)])
//       .range([0, width]);
//     const y = d3
//       .scaleBand()
//       .domain(completedWorkData.map((d) => d.location))
//       .range([0, height])
//       .padding(0.3);

//     svg
//       .append("g")
//       .attr("transform", `translate(0,${height})`)
//       .call(
//         d3
//           .axisBottom(x)
//           .ticks(4)
//           .tickFormat((v) => `${v}`),
//       )
//       .selectAll("text")
//       .style("font-size", "10px")
//       .style("fill", "#888780");
//     svg.select(".domain").style("display", "none");

//     svg.append("g").call(d3.axisLeft(y)).selectAll("text").style("font-size", "11px").style("fill", "#888780");
//     svg.selectAll(".domain").style("display", "none");

//     svg
//       .append("g")
//       .attr("class", "grid")
//       .call(
//         d3
//           .axisBottom(x)
//           .ticks(4)
//           .tickSize(height)
//           .tickFormat(() => ""),
//       )
//       .attr("transform", "translate(0,0)")
//       .selectAll("line")
//       .style("stroke", "rgba(136,135,128,0.15)")
//       .style("stroke-dasharray", "3,3");
//     svg.select(".grid .domain").remove();

//     svg
//       .selectAll(".bar")
//       .data(completedWorkData)
//       .enter()
//       .append("rect")
//       .attr("class", "bar")
//       .attr("x", 0)
//       .attr("y", (d) => y(d.location) || 0)
//       .attr("width", 0)
//       .attr("height", y.bandwidth())
//       .attr("fill", colors.kleenway.green)
//       .attr("rx", 4)
//       .style("opacity", 0.9)
//       .on("mouseover", function (this: SVGRectElement, _event, d) {
//         d3.select(this).style("opacity", 1);
//         const tooltip = svg
//           .append("g")
//           .attr("class", "tooltip")
//           .attr("transform", `translate(${x(d.count) + 6},${(y(d.location) || 0) + y.bandwidth() / 2})`);
//         tooltip
//           .append("rect")
//           .attr("x", 0)
//           .attr("y", -11)
//           .attr("width", 36)
//           .attr("height", 18)
//           .attr("fill", "rgba(0,0,0,0.7)")
//           .attr("rx", 3);
//         tooltip
//           .append("text")
//           .attr("x", 18)
//           .attr("text-anchor", "middle")
//           .attr("y", 3)
//           .attr("fill", "#ffffff")
//           .attr("font-size", "11px")
//           .text(d.count);
//       })
//       .on("mouseout", function (this: SVGRectElement) {
//         d3.select(this).style("opacity", 0.9);
//         svg.selectAll(".tooltip").remove();
//       })
//       .transition()
//       .duration(700)
//       .delay((_, i) => i * 40)
//       .ease(d3.easeQuadOut)
//       .attr("width", (d) => x(d.count));
//   }, [completedWorkData]);

//   return (
//     <WidgetContainer>
//       <Stack gap={2}>
//         <CardTitle>{caption}</CardTitle>
//         <ChartContainer ref={containerRef}>
//           {completedWorkData.length === 0 && <StateText>No data available</StateText>}
//           {completedWorkData.length > 0 && <svg ref={svgRef} style={{ width: "100%" }} />}
//         </ChartContainer>
//         <Footer>completed work orders</Footer>
//       </Stack>
//     </WidgetContainer>
//   );
// };

// export default WorkOrdersLocationChart;

// const WidgetContainer = styled.div`
//   display: flex;
//   min-width: 0;
//   background: #ffffff;
//   border: 0.5px solid rgba(0, 0, 0, 0.12);
//   border-radius: 12px;
//   padding: 16px;
// `;

// const ChartContainer = styled.div`
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   width: 100%;
//   overflow-x: auto;
// `;

// const CardTitle = styled.div`
//   font-size: 11px;
//   font-weight: 500;
//   color: ${colors.grey.dark};
//   letter-spacing: 0.06em;
//   text-transform: uppercase;
// `;

// const StateText = styled.span`
//   font-size: 13px;
//   color: ${colors.grey.dark};
//   padding: 24px 0;
// `;

// const Footer = styled.div`
//   font-size: 10px;
//   color: ${colors.grey.light10};
//   text-align: center;
//   border-top: 0.5px solid ${colors.grey.light11};
//   padding-top: 8px;
// `;

import React, { useEffect, useMemo, useRef } from "react";
import { Stack } from "react-bootstrap";
import { colors } from "src/styles";
import styled from "styled-components";
import * as d3 from "d3";

interface WorkOrderByLocation {
  locationName: string;
  count: number;
}

interface WidgetProps {
  caption: string;
  preloadedData?: { widgetsData: { workOrdersByLocation: WorkOrderByLocation[] } };
}

interface WorkOrderData {
  location: string;
  count: number;
}

const toNumber = (value: unknown): number => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

const WorkOrdersLocationChart = ({ caption, preloadedData }: WidgetProps) => {
  const svgRef = useRef<SVGSVGElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  const completedWorkData: WorkOrderData[] = useMemo(() => {
    return (preloadedData?.widgetsData?.workOrdersByLocation ?? [])
      .map((item, index) => ({
        location: String(item?.locationName ?? `Location ${index + 1}`),
        count: toNumber(item?.count),
      }))
      .sort((a, b) => b.count - a.count);
  }, [preloadedData]);

  useEffect(() => {
    if (!svgRef.current || completedWorkData.length === 0) return;

    // Left margin is minimal since labels are stacked above the bars
    // Right margin accounts for the vertical scrollbar width
    const margin = { top: 12, right: 24, bottom: 25, left: 5 };
    const containerWidth = containerRef.current?.clientWidth || 300;
    const width = containerWidth - margin.left - margin.right;

    const rowHeight = 44;
    const height = completedWorkData.length * rowHeight;

    d3.select(svgRef.current).selectAll("*").remove();

    const svg = d3
      .select(svgRef.current)
      .attr("width", width + margin.left + margin.right)
      .attr("height", height + margin.top + margin.bottom)
      .append("g")
      .attr("transform", `translate(${margin.left},${margin.top})`);

    const maxCount = d3.max(completedWorkData, (d) => d.count) || 0;
    const x = d3
      .scaleLinear()
      .domain([0, maxCount + Math.ceil(maxCount * 0.15)])
      .range([0, width]);

    const y = d3
      .scaleBand()
      .domain(completedWorkData.map((d) => d.location))
      .range([0, height])
      .paddingInner(0.2);

    // Bottom Axis (X Axis)
    svg
      .append("g")
      .attr("transform", `translate(0,${height})`)
      .call(
        d3
          .axisBottom(x)
          .ticks(4)
          .tickFormat((v) => `${v}`),
      )
      .selectAll("text")
      .style("font-size", "10px")
      .style("fill", "#888780");
    svg.select(".domain").style("display", "none");

    // Background Gridlines
    svg
      .append("g")
      .attr("class", "grid")
      .call(
        d3
          .axisBottom(x)
          .ticks(4)
          .tickSize(height)
          .tickFormat(() => ""),
      )
      .attr("transform", "translate(0,0)")
      .selectAll("line")
      .style("stroke", "rgba(136,135,128,0.15)")
      .style("stroke-dasharray", "3,3");
    svg.select(".grid .domain").remove();

    // Location Labels
    svg
      .selectAll(".location-label")
      .data(completedWorkData)
      .enter()
      .append("text")
      .attr("class", "location-label")
      .attr("x", 0)
      .attr("y", (d) => (y(d.location) || 0) + 14)
      .text((d) => d.location)
      .style("font-size", "11px")
      .style("font-weight", "500")
      .style("fill", colors.grey.dark);

    // Data Bars
    svg
      .selectAll(".bar")
      .data(completedWorkData)
      .enter()
      .append("rect")
      .attr("class", "bar")
      .attr("x", 0)
      .attr("y", (d) => (y(d.location) || 0) + 22)
      .attr("width", 0)
      .attr("height", 8)
      .attr("fill", colors.kleenway.green)
      .attr("rx", 4)
      .style("opacity", 0.9)
      .on("mouseover", function (this: SVGRectElement, _event, d) {
        d3.select(this).style("opacity", 1);

        const tooltip = svg
          .append("g")
          .attr("class", "tooltip")
          .attr("transform", `translate(${x(d.count) + 6},${(y(d.location) || 0) + 26})`);
        tooltip
          .append("rect")
          .attr("x", 0)
          .attr("y", -11)
          .attr("width", 36)
          .attr("height", 18)
          .attr("fill", "rgba(0,0,0,0.7)")
          .attr("rx", 3);
        tooltip
          .append("text")
          .attr("x", 18)
          .attr("text-anchor", "middle")
          .attr("y", 3)
          .attr("fill", "#ffffff")
          .attr("font-size", "11px")
          .text(d.count);
      })
      .on("mouseout", function (this: SVGRectElement) {
        d3.select(this).style("opacity", 0.9);
        svg.selectAll(".tooltip").remove();
      })
      .transition()
      .duration(700)
      .delay((_, i) => i * 40)
      .ease(d3.easeQuadOut)
      .attr("width", (d) => x(d.count));
  }, [completedWorkData]);

  return (
    <WidgetContainer>
      <Stack gap={2} style={{ minWidth: 0, width: "100%" }}>
        <CardTitle>{caption}</CardTitle>
        <ChartContainer ref={containerRef}>
          {completedWorkData.length === 0 && <StateText>No data available</StateText>}
          {completedWorkData.length > 0 && <svg ref={svgRef} style={{ width: "100%", display: "block" }} />}
        </ChartContainer>
        <Footer>completed work orders</Footer>
      </Stack>
    </WidgetContainer>
  );
};

export default WorkOrdersLocationChart;

const WidgetContainer = styled.div`
  display: flex;
  min-width: 0;
  background: #ffffff;
  border: 0.5px solid rgba(0, 0, 0, 0.12);
  border-radius: 12px;
  padding: 16px;
`;

// UPDATED: Added structural constraints for vertical scrolling
const ChartContainer = styled.div`
  display: block;
  width: 100%;
  max-height: 240px; /* Aligns comfortably with sibling cards in DashRow */
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 4px; /* Prevents scrollbar overlapping the graph elements */

  /* Sleek Minimalist Scrollbar Style */
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.15);
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background-color: rgba(0, 0, 0, 0.3);
  }
`;

const CardTitle = styled.div`
  font-size: 11px;
  font-weight: 500;
  color: ${colors.grey.dark};
  letter-spacing: 0.06em;
  text-transform: uppercase;
`;

const StateText = styled.span`
  font-size: 13px;
  color: ${colors.grey.dark};
  padding: 24px 0;
  text-align: center;
  display: block;
`;

const Footer = styled.div`
  font-size: 10px;
  color: ${colors.grey.light10};
  text-align: center;
  border-top: 0.5px solid ${colors.grey.light11};
  padding-top: 8px;
`;
